module.exports = __webpack_public_path__ + "img/logo-karcher.d7c8b179.png";